angular.module('unica_media_moderation.media_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// MEDIA
		.state('app.media_moderation', {
			url: '/media-moderation',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/media-moderation/templates/media-moderation.html',
					controller: 'MediaModerationBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// MEDIA LIST
			.state('app.media_moderation.list', {
				url: '/list/:event_id',
				views: {
					'mediaModerationContent': {
						templateUrl: './modules/media-moderation/templates/list.html',
						controller: 'MediaModerationListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Lista Media',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
					}
				}
			});


});

